import { ValidatorFn } from '@angular/forms';

export class FormEditor<T> {
  value?: T;
  key?: string;
  label?: string;
  validators?: ValidatorFn[];
  isMultilang?: boolean;
  containedMultilang?: boolean;
  controlType?: string;
  langKey?: string;
  boundTo?: string;
  formGroup?: string;
  apiUrl?: string;
  multiple?: boolean;
  imgOnly?: boolean;
  upload?: boolean;
  entity?: any;
  height?: number;
  wysiwyg?: string;
  placeholder?: string;
  entities?: any;
  canCreate?: boolean;
  hidden?: boolean;
  iconTemplate?: boolean;
  type?: string;
  options?: { value: string, text: string }[] = [];
  hideLabel?: boolean;
  fields?: Array<FormEditor<any>>;
  defaultValue?: T;

  constructor(options: any = {}) {
    this.value = options.value;
    this.key = options.key;
    this.label = options.label;
    this.validators = options.validators;
    this.isMultilang = options.isMultilang;
    this.containedMultilang = options.containedMultilang;
    this.controlType = options.controlType;
    this.langKey = options.langKey;
    this.boundTo = options.boundTo;
    this.formGroup = options.formGroup;
    this.apiUrl = options.apiUrl;
    this.multiple = options.multiple;
    this.imgOnly = options.imgOnly;
    this.upload = options.upload;
    this.entity = options.entity;
    this.height = options.height;
    this.wysiwyg = options.wysiwyg;
    this.placeholder = options.placeholder;
    this.entities = options.entities;
    this.canCreate = options.canCreate;
    this.hidden = options.hidden;
    this.iconTemplate = options.iconTemplate;
    this.type = options.type;
    this.options = options.options;
    this.hideLabel = options.hideLabel;
    this.fields = options.fields;
    this.defaultValue = options.defaultValue;
  }
}

export const FIELD_TYPES = { 'array': ['tags', 'containedMany', 'containedFormFields', 'parameters'], 'boolean': ['switch'] };
